import { useCallback } from 'react';
import { useAsset } from '@artica/assets';
import { parallax } from '@immutabl3/alchemy/three';
import {
  MathUtils,
  DoubleSide,
  AdditiveBlending,
} from 'three';

const remap = (value, low1, high1, low2, high2) => {
  return low2 + (high2 - low2) * (value - low1) / (high1 - low1);
};

export default function CompetitionCardPath({
  geometry,
  position,
  rotation,
  scale,
  animation,
}) {
  const tex = useAsset('dot_sprite_2');
  const z = position[2];
  const onAnimation = useCallback((mat, anim) => {
    const { animations } = anim;
    const [{ currentValue: opacity }] = animations;
    const zOffset = remap(z, -119.0, -278.0, 0.0, 2.0);
    mat.opacity = MathUtils.clamp(opacity - zOffset, 0, 1);
  }, [z]);

  return (
    <mesh
      geometry={ geometry }
      position={ position }
      rotation={ rotation }
      scale={ scale }
    >
      <parallax.meshBasicMaterial
        beaker="chapter1"
        animation={ animation }
        onAnimation={ onAnimation }

        side={ DoubleSide }
        color={ [1, 0.7, 0.5] }
        map={ tex }
        fog={ false }
        blending={ AdditiveBlending }
        depthWrite={ false }
        transparent
      />
    </mesh>
  );
};